class RegisterController {

  constructor(authenticateApi, basket, storeService, propertyService) {
    this.authenticateApi = authenticateApi;
    this.basket = basket;
    this.storeService = storeService;
    this.propertyService = propertyService;
  }

  $onInit () {
    if (!!this.storeService.get('client_id')
            || !!this.storeService.get('reservation')) {
      this.hasAccount = true;
      return;
    }

    return this.basket.promise.then(() => {
      this.canSubmit = true;
    });
  }

  register () {
    if (this.validateForm()) {
      this.saving = true;

      return this.authenticateApi.register({
        title: this.title,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        gender: this.gender,
        password: this.password,
        basketCode: this.basket.contents.identity_code
      })
        .then(response => {
          this.storeService.set('client_id', response.client);
          this.storeService.set('client_name', response.name);
          this.storeService.set('basket', response.basket);
          this.success = true;
        })
        .catch(() => {
          this.error = 'Sorry, there was a problem registering your account. Please try again or contact us.';
        })
        .then(() => {
          this.saving = false;
        });
    }
  }

  validateForm () {
    this.error = null;
    this.errorSuggestion = null;

    if (!this.title
            || !this.firstName
            || !this.lastName
            || !this.email
            || !this.gender
            || !this.password) {
      this.error = 'Please fill all fields';
      return false;
    }

    if (this.password.length < 8) {
      this.error = 'Please enter a longer password';
      this.errorSuggestion = 'It must be at least 8 characters in length';
      return false;
    }

    if (!this.strength || this.strength.score <= 2) {
      this.error = 'Please enter a stronger password';
      this.errorSuggestion = this.strength.feedback.suggestions.join(' ');
      return false;
    }

    return true;
  }

  guessGender () {
    let female = [ 'Miss', 'Mrs.', 'Ms.' ];

    if (this.title) {
      if (this.title === 'Mr.') {
        this.gender = 'M';
        return;
      }

      if (female.find(title => title === this.title)) {
        this.gender = 'F';
      }
    }
  }

  displayName () {
    return this.storeService.get('client_name');
  }

  displayEventTypes () {
    let types = [];
    let link = '';

    if (this.propertyService.get('hasTreatments')) {
      link = '/treatments';
      if (this.propertyService.get('listTreatments')) {
        link = '/categories/treatments';
      }
      types.push(`<a href="${link}">Treatments</a>`);
    }

    if (this.propertyService.get('hasSpaDays')) {
      link = '/spa-days';
      if (this.propertyService.get('listSpaDays')) {
        link = '/categories/spa-days';
      }
      types.push(`<a href="${link}">Spa Days</a>`);
    }

    if (this.propertyService.get('hasActivities')) {
      types.push(`<a href="/activities">Activities</a>`);
    }

    if (types) {
      return types.join(' or ');
    }

    return '';
  }

  displayForm () {
    return !(this.hasAccount || this.success);
  }

  displayCheckoutLink () {
    return `<a href="/checkout/${this.basket.contents.first_step}">continue to checkout</a>`;
  }
}
RegisterController.$inject = [ 'authenticateApi', 'basket', 'storeService', 'propertyService' ];

export default RegisterController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/controllers/register.controller.js